/**
 * @generated SignedSource<<226191c77684359abd2c348403626030>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type resume_ResumeSubscription$variables = {
  userId?: string | null | undefined;
};
export type resume_ResumeSubscription$data = {
  readonly resumeProcessingFinished: {
    readonly resume: {
      readonly id: string;
      readonly user: {
        readonly resume: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"resume_useIsImportingResume">;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"FullProfile_User">;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"resume_useIsImportingResume">;
    } | null | undefined;
  };
};
export type resume_ResumeSubscription = {
  response: resume_ResumeSubscription$data;
  variables: resume_ResumeSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "resume_useIsImportingResume"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importTimeoutAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "copyToProfile",
  "storageKey": null
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  (v2/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currency",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v16 = [
  (v14/*: any*/),
  (v2/*: any*/)
],
v17 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statuses": [
        "expired"
      ]
    }
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "resume_ResumeSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResumeProcessingFinishedPayload",
        "kind": "LinkedField",
        "name": "resumeProcessingFinished",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Resume",
            "kind": "LinkedField",
            "name": "resume",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Resume",
                    "kind": "LinkedField",
                    "name": "resume",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FullProfile_User"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resume_ResumeSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResumeProcessingFinishedPayload",
        "kind": "LinkedField",
        "name": "resumeProcessingFinished",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Resume",
            "kind": "LinkedField",
            "name": "resume",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Resume",
                    "kind": "LinkedField",
                    "name": "resume",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "success",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "avatarUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featured",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureStepCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "workingOrOfferedJob",
                    "storageKey": null
                  },
                  {
                    "alias": "jobApplications",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "statuses": [
                            "job_application_draft"
                          ]
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      }
                    ],
                    "concreteType": "JobApplicationConnection",
                    "kind": "LinkedField",
                    "name": "freelancerJobApplications",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_draft\"]},first:1)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "self",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "openToOpportunities",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Industry",
                        "kind": "LinkedField",
                        "name": "industry",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "profilesRequireSkills",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Specialization",
                        "kind": "LinkedField",
                        "name": "specializations",
                        "plural": true,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textIntroduction",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds0",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds3",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationLatitude",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationLongitude",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullAddress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlBlog",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlDribbble",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlGithub",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlLinkedin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availability",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canWorkInTheUs",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "managedTeamSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availabilityType",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Money",
                        "kind": "LinkedField",
                        "name": "freelancerRate",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Money",
                        "kind": "LinkedField",
                        "name": "clientRate",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobTypes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rateMode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalExperience",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visibility",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "region",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Country",
                        "kind": "LinkedField",
                        "name": "country",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zip",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundCheckCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimelineEntry",
                    "kind": "LinkedField",
                    "name": "timelineEntries",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entryType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "place",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateEnd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Institute",
                        "kind": "LinkedField",
                        "name": "institute",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "worldRankRange",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rankingYear",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Company",
                        "kind": "LinkedField",
                        "name": "company",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "custom",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "skills",
                        "plural": true,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserSkill",
                    "kind": "LinkedField",
                    "name": "userSkills",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "experience",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "skill",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "video",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "posterUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "public",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Question",
                        "kind": "LinkedField",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rawId",
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "statuses": [
                            "job_application_draft",
                            "job_application_invited",
                            "job_application_sent",
                            "screening_requested",
                            "screening_started",
                            "screening_completed",
                            "interview",
                            "offer",
                            "hired"
                          ]
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 10
                      }
                    ],
                    "concreteType": "JobApplicationConnection",
                    "kind": "LinkedField",
                    "name": "freelancerJobApplications",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobApplication",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Job",
                            "kind": "LinkedField",
                            "name": "job",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Firm",
                            "kind": "LinkedField",
                            "name": "firm",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_draft\",\"job_application_invited\",\"job_application_sent\",\"screening_requested\",\"screening_started\",\"screening_completed\",\"interview\",\"offer\",\"hired\"]},first:10)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BlogPostConnection",
                    "kind": "LinkedField",
                    "name": "blogPosts",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Reference",
                    "kind": "LinkedField",
                    "name": "references",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectSubmission",
                    "kind": "LinkedField",
                    "name": "projectSubmissions",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "contracts",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": "contracts(filters:{\"statuses\":[\"expired\"]})"
                  },
                  {
                    "alias": "expiredContracts",
                    "args": (v17/*: any*/),
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": "freelancerContracts(filters:{\"statuses\":[\"expired\"]})"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "191abd4196bc3dc85697b10235442c6f",
    "id": null,
    "metadata": {},
    "name": "resume_ResumeSubscription",
    "operationKind": "subscription",
    "text": "subscription resume_ResumeSubscription(\n  $userId: ID\n) {\n  resumeProcessingFinished(userId: $userId) {\n    resume {\n      id\n      ...resume_useIsImportingResume\n      user {\n        resume {\n          id\n          ...resume_useIsImportingResume\n        }\n        ...FullProfile_User\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityAndPositionTypeFields_User on User {\n  ...AvailabilityEditDialog_User\n  ...AvailabilityBadge_User\n}\n\nfragment AvailabilityBadge_User on User {\n  profile {\n    availability\n    availabilityType\n    availableAt\n    id\n  }\n  timezone\n}\n\nfragment AvailabilityEditDialog_User on User {\n  profile {\n    availability\n    availableAt\n    availabilityType\n    id\n  }\n}\n\nfragment AvatarField_User on User {\n  avatarUrl\n}\n\nfragment BadgesArea_User on User {\n  backgroundCheckCompleted\n  status\n  profile {\n    availability\n    canWorkInTheUs\n    managedTeamSize\n    id\n  }\n  ...AvailabilityAndPositionTypeFields_User\n  ...StatusField_User\n  ...TeamManagementField_User\n  ...USWorkField_User\n}\n\nfragment CompensationSummary_User on User {\n  self\n  profile {\n    currency {\n      code\n      id\n    }\n    freelancerRate {\n      value\n    }\n    clientRate {\n      value\n    }\n    jobTypes\n    rateMode\n    id\n  }\n}\n\nfragment CreateProfileStep_User on User {\n  status\n  profile {\n    openToOpportunities\n    id\n  }\n  contracts(filters: {statuses: [expired]}) {\n    totalCount\n  }\n}\n\nfragment ExperienceSummary_User on User {\n  profile {\n    totalExperience\n    id\n  }\n}\n\nfragment FeatureProfileStep_User on User {\n  blogPosts {\n    totalCount\n  }\n  references {\n    id\n  }\n  answers {\n    id\n  }\n  projectSubmissions {\n    id\n  }\n}\n\nfragment FreelancerProfileHead_User on User {\n  firstName\n  lastName\n  avatarUrl\n  email\n  profile {\n    slug\n    industry {\n      name\n      id\n    }\n    fullAddress\n    region\n    country {\n      name\n      id\n    }\n    city\n    zip\n    textIntroduction\n    id\n  }\n  video {\n    posterUrl\n    id\n  }\n}\n\nfragment FreelancerProfileShareButton_User on User {\n  status\n  profile {\n    slug\n    id\n  }\n}\n\nfragment FreelancerProfile_User on User {\n  id\n  self\n  status\n  profile {\n    openToOpportunities\n    id\n  }\n  ...Summary_UserProfile\n  ...TimelineEntriesField_User\n  ...UserSkillsFields_User\n  ...VideoField_User\n  ...VideoAnswersField_User\n}\n\nfragment FreelancerProfile_UserScene on User {\n  id\n  self\n  ...FreelancerProfileHead_User\n  ...FreelancerProfile_User\n}\n\nfragment FullProfile_User on User {\n  id\n  status\n  avatarUrl\n  featured\n  featureStepCompleted\n  resume {\n    id\n    ...resume_useIsImportingResume\n  }\n  ...ProfileForm_User\n  ...useFullProfileSubmit_User\n  ...ProfileGuideStepper_User\n  ...ProfileAvatar_User\n  ...HeaderCompletionText_User\n  ...ResumeUploadBox_User\n  ...ResumeUploadRow_User\n  ...HeaderCopy_User\n}\n\nfragment HeaderCompletionText_User on User {\n  status\n  featureStepCompleted\n  featured\n}\n\nfragment HeaderCopy_User on User {\n  status\n  featureStepCompleted\n  featured\n  profile {\n    openToOpportunities\n    id\n  }\n  expiredContracts: freelancerContracts(filters: {statuses: [expired]}) {\n    totalCount\n  }\n}\n\nfragment IndustryField_User on User {\n  profile {\n    industry {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment LocationFields_User on User {\n  profile {\n    locationBounds0\n    locationBounds1\n    locationBounds2\n    locationBounds3\n    locationLatitude\n    locationLongitude\n    fullAddress\n    id\n  }\n}\n\nfragment NameFields_User on User {\n  firstName\n  lastName\n}\n\nfragment OpenToOpportunitiesToggle_User on User {\n  id\n  profile {\n    openToOpportunities\n    id\n  }\n}\n\nfragment ProfileAvatar_User on User {\n  featureStepCompleted\n  featured\n  status\n  ...UserAvatarContainer_User\n}\n\nfragment ProfileForm_User on User {\n  status\n  workingOrOfferedJob\n  ...useIsApplyingToJob_User\n  ...FreelancerProfile_User\n  ...VanityUrl_User\n  ...VisibilitySelect_User\n  ...FreelancerProfile_UserScene\n  ...useFullProfileSubmit_User\n  ...OpenToOpportunitiesToggle_User\n}\n\nfragment ProfileGuideStepper_User on User {\n  status\n  featured\n  featureStepCompleted\n  ...FeatureProfileStep_User\n  ...VerifyProfileStep_User\n  ...CreateProfileStep_User\n}\n\nfragment ProfileRateFields_User on User {\n  ...CompensationSummary_User\n  ...ExperienceSummary_User\n  ...RateEditDialog_User\n}\n\nfragment RateEditDialog_User on User {\n  profile {\n    freelancerRate {\n      value\n      currency {\n        code\n        id\n      }\n    }\n    jobTypes\n    rateMode\n    id\n  }\n}\n\nfragment ResumeUploadBox_User on User {\n  status\n  resume {\n    status\n    success\n    ...resume_useIsImportingResume\n    id\n  }\n}\n\nfragment ResumeUploadRow_User on User {\n  ...ResumeUploadBox_User\n}\n\nfragment SocialLinksEditDialog_User on User {\n  profile {\n    urlBlog\n    urlDribbble\n    urlGithub\n    urlLinkedin\n    id\n  }\n}\n\nfragment SocialLinksFields_User on User {\n  profile {\n    urlBlog\n    urlDribbble\n    urlGithub\n    urlLinkedin\n    id\n  }\n  resume {\n    url\n    id\n  }\n  ...SocialLinksEditDialog_User\n}\n\nfragment SpecializationFieldsDialog_User on User {\n  profile {\n    industry {\n      id\n    }\n    specializations {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment Specialization_Specialization on Specialization {\n  id\n  name\n}\n\nfragment SpecializationsFields_User on User {\n  profile {\n    industry {\n      id\n    }\n    specializations {\n      id\n      name\n      ...Specialization_Specialization\n    }\n    id\n  }\n  ...SpecializationFieldsDialog_User\n}\n\nfragment StatusField_User on User {\n  status\n}\n\nfragment Summary_UserProfile on User {\n  profile {\n    openToOpportunities\n    id\n  }\n  ...SpecializationsFields_User\n  ...TextIntroductionField_User\n  ...LocationFields_User\n  ...AvatarField_User\n  ...NameFields_User\n  ...IndustryField_User\n  ...SocialLinksFields_User\n  ...BadgesArea_User\n  ...ProfileRateFields_User\n}\n\nfragment TeamManagementField_User on User {\n  profile {\n    managedTeamSize\n    id\n  }\n}\n\nfragment TextIntroductionField_User on User {\n  profile {\n    textIntroduction\n    id\n  }\n}\n\nfragment TimelineEntriesField_TimelineEntries on TimelineEntry {\n  id\n  entryType\n  place\n  title\n  dateStart\n  dateEnd\n  description\n  institute {\n    worldRankRange\n    rankingYear\n    id\n  }\n  company {\n    custom\n    id\n  }\n  skills {\n    id\n    name\n  }\n}\n\nfragment TimelineEntriesField_User on User {\n  profile {\n    industry {\n      id\n    }\n    id\n  }\n  timelineEntries {\n    ...TimelineEntriesField_TimelineEntries\n    id\n  }\n}\n\nfragment USWorkField_User on User {\n  profile {\n    canWorkInTheUs\n    id\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment UserSkillsEditDialog_User on User {\n  id\n  profile {\n    industry {\n      id\n      name\n    }\n    id\n  }\n  userSkills {\n    experience\n    skill {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment UserSkillsFields_User on User {\n  ...UserSkillsEditDialog_User\n  profile {\n    industry {\n      profilesRequireSkills\n      id\n    }\n    id\n  }\n  userSkills {\n    experience\n    skill {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment VanityUrl_User on User {\n  profile {\n    slug\n    id\n  }\n  ...FreelancerProfileShareButton_User\n}\n\nfragment VerifyProfileStep_User on User {\n  status\n  avatarUrl\n}\n\nfragment VideoAnswersField_User on User {\n  answers {\n    id\n    url\n    public\n    question {\n      rawId\n      title\n      id\n    }\n  }\n}\n\nfragment VideoField_User on User {\n  video {\n    id\n  }\n}\n\nfragment VisibilitySelect_User on User {\n  profile {\n    visibility\n    id\n  }\n}\n\nfragment resume_useIsImportingResume on Resume {\n  id\n  status\n  importTimeoutAt\n  copyToProfile\n  user {\n    id\n  }\n}\n\nfragment useFullProfileSubmit_User on User {\n  status\n  freelancerJobApplications(first: 10, filters: {statuses: [job_application_draft, job_application_invited, job_application_sent, screening_requested, screening_started, screening_completed, interview, offer, hired]}) {\n    nodes {\n      status\n      job {\n        slug\n        id\n      }\n      firm {\n        slug\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment useIsApplyingToJob_User on User {\n  jobApplications: freelancerJobApplications(filters: {statuses: [job_application_draft]}, first: 1) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "842e2677a0acd2102a1f9850d6d62360";

export default node;
